<template>
  <div class="event-block open-hours-block block" :class="{ hide }" @click="hide = false">
    <div class="head">
      <div class="title">{{ $t('events.open-hours.title') }}</div>
      <TimeDurEvent :event="event" />
    </div>
    <div class="hosts" v-if="host">
      <div class="user">
        <Avatar size="sm" :src="host.avatar" />
        <div class="name">{{ host.first_name }} {{ host.last_name }}</div>
      </div>
    </div>
    <div class="participants" v-if="false">
      <div class="users">
        <Avatar size="sm" v-for="i in 2" :key="i" />
        <Avatar size="sm other">+2</Avatar>
      </div>
      <div class="about">
        <template v-if="!hide"> {{ $t('events.open-hours.about.persons') }} </template>
        <template v-else>
          {{ $t('events.open-hours.about.private') }}
        </template>
      </div>
    </div>
    <div class="actions">
      <a :href="event.zoom_link" target="_blank" v-if="isActualEvent">
        <button class="primary">{{ $t('events.open-hours.join') }}</button>
      </a>
      <button class="hide" @click.stop="hide = true">{{ $t('events.open-hours.hide') }}</button>
      <img class="arrow" src="@/assets/icons/arrow.svg" alt="" />
    </div>
  </div>
</template>

<script>
import TimeDurEvent from '@/components/events/TimeDurEvent'
import Avatar from '@/components/user/Avatar'
import isActualEvent from '../../mixins/isActualEvent'

export default {
  name: 'OpenHours',
  components: { Avatar, TimeDurEvent },
  mixins: [isActualEvent],
  props: {
    event: {},
  },
  data: () => ({
    hide: false,
  }),
  computed: {
    host() {
      return this.event.user && this.event.experts[0]
    },
  },
  watch: {
    hide(v) {
      this.$emit('change', v)
    },
  },
}
</script>

<style lang="scss">
.open-hours-block {
  margin: 12px 0;
  transition: all 0.25s;

  .head {
    margin-bottom: 16px;
  }

  .hosts {
    margin-bottom: 12px;
  }

  .participants {
    display: flex;
    align-items: center;
    margin-bottom: 14px;

    .users {
      display: flex;
      margin-right: 16px;
      margin-left: -2px;

      .avatar {
        border: 2px solid $white;
        width: 26px;
        height: 26px;
        border-radius: 7px;

        @include flexCenter;
        font-weight: bold;
        font-size: 9px;
        line-height: 113.5%;
        color: $dark;

        &:not(:first-child) {
          margin-left: -10px;

          &.other {
            margin-left: 5px;
          }
        }
      }
    }

    .about {
      font-weight: bold;
      font-size: 10px;
      line-height: 123%;
      color: $dark;
    }
  }

  .actions {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 6px;

    a {
      text-decoration: none;
    }

    .arrow {
      display: none;
    }

    button {
      width: 100%;
    }
  }

  &.hide {
    display: flex;
    padding: 5px 12px 4px 5px;
    min-height: 22px;
    cursor: pointer;

    .head {
      position: absolute;
      top: 5px;
      left: 37px;
      margin: 0;

      .title {
        font-size: 10px;
        line-height: 12px;
        margin: 0;
      }
    }

    .time-dur-event {
      order: -1;

      .time span,
      .dur {
        display: none;
      }

      .online-status-dote {
        margin-right: 4px;
        margin-top: 1px;
      }
    }

    .hosts {
      order: -1;
      margin: 0;

      .user {
        align-items: flex-end;
        margin: 0;

        .avatar {
          width: 25px;
          height: 25px;
          margin-right: 7px;
        }

        .name {
          font-size: 9px;
          line-height: 11px;
          flex-shrink: 0;
          white-space: nowrap;
        }
      }
    }

    .participants {
      margin: 0 6px;
      margin-left: auto;

      .users {
        margin-right: 6px;

        .avatar {
          width: 20px;
          height: 20px;
          border-radius: 6px;

          &.other:not(:first-child) {
            margin-left: 2px;
          }
        }
      }

      .about {
        width: 100px;
        flex-shrink: 2;
      }
    }

    .actions {
      @include flexCenter;
      flex-shrink: 0;
      margin-left: auto;

      .arrow {
        display: block;
      }

      button {
        display: none;
      }
    }
  }

  &.vertical {
    padding-top: 16px;
    padding-bottom: 70px;
    margin: 10px 0;

    @include PC {
      margin: 0 7px;
    }

    .head {
      position: static;
      margin: 0;

      .title {
        text-align: left;
        width: 100%;
      }

      @include PC {
        .title {
          margin-top: 38px;
        }
      }
    }

    .time-dur-event {
      @include PC {
        order: -1;
      }
    }

    .participants {
      align-items: flex-start;
      flex-direction: column;
      margin: 0;

      .users {
        margin-bottom: 6px;
      }
    }

    .actions {
      position: absolute;
      bottom: 16px;
      left: 20px;
      right: 20px;
      grid-template-columns: 1fr;

      .hide {
        display: none;
      }
    }
  }
}
</style>
